import React, { useEffect, useState } from "react";
import FilterSelect from "component/common/FilterSelect";
import Search from "component/common/TableFilter/Search";
import queryString from "query-string";
import { useHistory, useLocation } from "react-router";
import { debounce } from "debounce";

import styles from "./PaymentFilter.module.scss";

const PaymentFilter = ({ page = "" }) => {
  const location = useLocation();

  const history = useHistory();

  const [paymentStatus, setPaymentStatus] = useState("Status");
  const [amount, setAmountSort] = useState("Sort By");

  let [filter, setFilter] = useState({
    // sellerid: undefined,
    sellername: undefined,
    upi: undefined,
    sort: undefined,
    mobile: undefined,
    email: undefined,
    product: undefined,
    amount: undefined,
    paymentStatus: undefined,
    common: undefined,
    sellerId_by_user: undefined,
  });

  const paymentStatusOptions = [
    "Processing",
    "Processed",
    "Scheduled",
    "Queued",
    "Cancelled",
    "Reversed",
    "Pending",
  ];

  // const sortOptions = ["Sort By", "Low to High", "High to Low"];

  useEffect(() => {
    let query = queryString.parse(location.search);
    console.log(query, "query.sellerId_by_user");
    let data = {
      ...filter,
      // sellerid: query.sellerid == "" ? undefined : query.sellerid,
      sellerId_by_user:
        query.sellerId_by_user === "" ? undefined : query.sellerId_by_user,
      sellername: query.name === "" ? undefined : query.sellername,
      upi: query.upi === "" ? undefined : query.upi,
      mobile: query.mobile === "" ? undefined : query.mobile,
      email: query.email === "" ? undefined : query.email,
      product: query.product === "" ? undefined : query.product,
      common: query.common === "" ? undefined : query.common,
      paymentStatus: query.paymentStatus?.toLowerCase(),
      amount:
        query.amount != undefined
          ? query.amount == "1"
            ? "Low to High"
            : "High to Low"
          : undefined,
      // amount:
      //   query.amount != undefined
      //     ? query.amount == "2"
      //       ? "High to Low"
      //       : "Low to High"
      //     : undefined,
    };
    console.log(query.upi, "query.upi");
    setFilter(data);
    setPaymentStatus(query.paymentStatus);
    setAmountSort(query.amount);
  }, [location.search]);

  const handleChange = (event) => {
    let data = { ...filter, [event.name]: event.value };
    console.log(data, "handle_data");
    let params = {
      // sellerid: data.sellerid == "" ? undefined : data.sellerid,
      sellerId_by_user:
        data.sellerId_by_user === "" ? undefined : data.sellerId_by_user,
      sellername: data.sellername === "" ? undefined : data.sellername,
      upi: data.upi === "" ? undefined : data.upi,
      mobile: data.mobile === "" ? undefined : data.mobile,
      email: data.email === "" ? undefined : data.email,
      product: data.product === "" ? undefined : data.product,
      paymentStatus: data.paymentStatus?.toLowerCase(),
      amount:
        data.amount === "Low to High"
          ? "1"
          : data.amount === "High to Low"
          ? "2"
          : undefined,
    };

    setFilter(data);
    setPaymentStatus(data.paymentStatus);
    setAmountSort(data.amount);

    if (queryString.stringify(params).length === 0) {
      history.push(`/admin/${page}/list`);
    } else {
      history.push(`/admin/${page}/list?${queryString.stringify(params)}`);
    }
  };

  return (
    <tr className={styles.disputed_filter}>
      {console.log(filter.sellerId_by_user, "filter.sellerId_by_user")}
      <td align="center">
        <Search
          name="sellerId_by_user"
          onChange={debounce(handleChange, 500)}
          value={filter.sellerId_by_user ? filter.sellerId_by_user : ""}
          searchPlaceholder="Search Seller Id"
        />
      </td>
      <td align="center">
        <Search
          name="sellername"
          onChange={debounce(handleChange, 500)}
          value={filter.sellername ? filter.sellername : ""}
          searchPlaceholder="Search Name"
        />
      </td>
      <td align="center">
        <Search
          name="mobile"
          onChange={debounce(handleChange, 500)}
          value={filter.mobile ? filter.mobile : ""}
          searchPlaceholder="Search Mobile"
        />
      </td>
      <td align="center">
        <Search
          name="email"
          onChange={debounce(handleChange, 500)}
          value={filter.email ? filter.email : ""}
          searchPlaceholder="Search Email"
        />
      </td>
      <td align="center">
        <Search
          name="product"
          onChange={debounce(handleChange, 500)}
          value={filter.product ? filter.product : ""}
          searchPlaceholder="Search Product"
        />
      </td>
      <td>
        {/* <Search
          name="upi"
          onChange={debounce(handleChange, 500)}
          value={filter.upi ? filter.upi : ""}
          searchPlaceholder="Seller Upi"
        /> */}
      </td>

      <td>
        {/* <FilterSelect
          options={sortOptions}
          placeholder="Sort By"
          isSort={true}
          name="amount"
          value={filter.amount ? filter.amount : "Sort By"}
          onChange={handleChange}
        /> */}
      </td>
      <td>
        <FilterSelect
          options={paymentStatusOptions}
          placeholder="Status"
          // isSort={false}
          name="paymentStatus"
          value={paymentStatus}
          onChange={handleChange}
          className="payment-filter"
        />
      </td>

      <td></td>

      <td></td>
    </tr>
  );
};

export default PaymentFilter;
